export default "__VITE_ASSET__CpZ_Bv$A__"